/**
 * Created by guga on 7/21/2016.
 */
import {SpacialBean} from './spacial.bean';
export class ItemBean {


    public action;
    public param;
    public closeAction;
    public closeParam


    public objectId : string; //IDENTIFIER OF THIS ITEM
    public tokenId:string;
    public tokenQtd:number;
    public name: string; //Item name;
    public description: string;
    public quantity:number //how many of this item is stacked
    public cost:number
    public location:string 
    public lastTransaction;


    public event: string; //Identifier Event where this item works
    public room: string; //Idnetifier of the room where this item might be
    public recipeId: string; //Recipe where this item came from


    //Liveplanet specific
    public kind: string; //Behaviour for the item
    public triggers:{};


    
    public src:  string
    public thumbnail:string ///Address of colored image goes to the gameserver and the bag
    public model:string;
    public colours:[]
    public size: number;
    public orientation: number;


    public where:string //where it is equiped
    public dimension:SpacialBean
    public collision:boolean


    public masterpiece:boolean
    public static:boolean

    public owner: string;
    public admin: string[];


    //game information
    public position:SpacialBean
    public rotation:SpacialBean
    public scale: SpacialBean

    public equipped:boolean //1 equipped 0 unequipped
    public version=3;
    public space:string

    constructor (){
        let date=new Date();
        let time=date.getTime();
        this.objectId=time.toString(); //IDENTIFIER OF THIS recipe
        this.tokenId='';
        this.tokenQtd=1;
        this.name="" //Item name;
        this.quantity=0; //how many of this item is base to be added on skill success
        this.cost=0; //sugested cost for item
        this.event='1592880902713';
        this.description="";
        this.thumbnail=""; //address of uncolored image
        this.model="";
        this.dimension=new SpacialBean();
        this.collision=false
        this.position=new SpacialBean();
        this.rotation=new SpacialBean();
        this.scale=new SpacialBean();

        this.size=1;
        this.colours=[]
        this.orientation=0;//0 to 4
        this.owner="";
        this.admin=[]
        this.lastTransaction=""
        this.location='bag';

        this.src="";
        this.kind=""; //Behaviour for the item
        this.triggers={}
        this.room=""

        this.masterpiece=false;
        this.static=false;
        this.where='';
        this.equipped=false;
        this.recipeId=''
        this.space=''

    }
    public makeNFT(){
        let nft={"name":this.name,
                "description":this.description,
                "symbol":this.recipeId,
                "collection":{"name":"Liveplanet","family":"Liveplanet"},
                "seller_fee_basis_points":0,
                "files":[
                    {"uri":this.thumbnail,"type":"image/png"}
                    ],
                "attributes":[
                    {"trait_type":"recipeId","value":"1639442415373"},
                    {"trait_type":"triggers","value":this.triggers},
                    {"trait_type":"dimensionX","value":this.dimension.x},
                    {"trait_type":"dimensionY","value":this.dimension.y},
                    {"trait_type":"dimensionZ","value":this.dimension.z},
                    {"trait_type":"kind","value":"craft"},                  
                ],
                "properties":{
                    "creators":[{"address":"26v9WoU8HvpE1DrSgqcyJQZQxKBtPbfJvg1UN173BmNP","share":100}],
                    "maxSupply":1}
                }
                return nft;
    }
    public parse(val){
        let date=new Date();
        let milis=date.getTime().toString()
        let id=val.id;
        id=id ? id : milis
        this.objectId=val.objectId ? val.objectId : id; //IDENTIFIER OF THIS recipe
        this.tokenId=val.tokenId ? val.tokenId : id; //IDENTIFIER OF THIS recipe
        this.tokenQtd = val.tokenQtd ? val.tokenQtd : 1

        this.name=val.name ? val.name : ''//Item name;
        this.quantity=val.quantity ? val.quantity : 0; //how many of this item is base to be added on skill success
        this.cost=val.cost ? val.cost : 0; //sugested cost for item
        this.owner=val.owner ? val.owner : ''
        this.admin=val.admin ? val.admin : []
        this.lastTransaction=val.lastTransaction ? val.lastTransaction :  ''
        this.location=val.location ? val.location : 'bag';

        this.thumbnail=val.thumbnail ? val.thumbnail : ''; //address of uncolored image
        this.model=val.model ? val.model : '';
        this.dimension=new SpacialBean();
        this.dimension.parse(val.dimension)
        this.collision=val.collision ? val.collision : ''
        this.orientation=val.orientation ? val.orientation : 0
        this.colours=val.colours ? val.colours : {}
        this.size = val.size ? val.size : 1
        this.src=val.src ? val.src : '';
        this.kind=val.kind ? val.kind : ''; //Behaviour for the item
        this.triggers=val.triggers ? val.triggers : {}

        this.masterpiece=val.masterpiece ? val.masterpiece : false;
        this.static=val.static ? val.static : false;

        this.event=val.event ? val.event : '1592880902713'; //Identifier Event where this item works
        this.room=val.room ? val.room : ''; //Idnetifier of the room where this item might be
        this.recipeId= val.recipeId ? val.recipeId : ''; //Recipe where this item came from

        this.position=new SpacialBean();
        this.position.parse(val.position)


        this.rotation=new SpacialBean();
        this.rotation.parse(val.rotation)

        this.scale=new SpacialBean();
        this.scale.parse(val.scale)

        this.space=val.space ? val.space : '';
        this.equipped = val.equipped ? val.equipped : false;
        this.where = val.where ? val.where : ''

    }
    public toDB() {
        return {
            objectId : this.objectId, //IDENTIFIER OF THIS recipe
            name: this.name, //Item name;
            quantity:this.quantity, //how many of this item is base to be added on skill success
            cost: this.cost, //sugested cost for item
            tokenId: this.tokenId,
            tokenQtd: this.tokenQtd,
            //item related
            kind: this.kind, //Behaviour for the item
            triggers : this.triggers,
            src: this.src,

            location: this.location,


            thumbnail:this.thumbnail, //address of uncolored image
            model:this.model,
            dimension: this.dimension.toDB(),
            collision: this.collision,
            orientation:this.orientation,
            colours:this.colours,
            size:this.size,
            owner: this.owner,
            admin: this.admin,
            lastTransaction: this.lastTransaction,

            event:this.event,
            room:this.room,
            recipeId: this.recipeId,
            position:this.position.toDB(),
            rotation:this.rotation.toDB(),
            scale: this.scale.toDB(),
            masterpiece:this.masterpiece,
            static:this.static,


            space:this.space,

            equipped:this.equipped,
            where:this.where,
            version:4
        }
    }
};




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/item.bean.ts